import classNames from "classnames";
import { compact } from "lodash";
import { Row } from "PFApp/booking/types";
import React, { JSX } from "react";

import css from "../side_panel_rows.module.scss";
import { useUtilization } from "./hooks";
import { RowBadge } from "./row_badge";
import { RowExpander } from "./row_expander";
import { RowName } from "./row_name";
import { useInfoText } from "./use_info_text";
import { useRowHoursBooked } from "./use_row_hours_booked";
import { Utilization } from "./utilization";
import WarningIconsPanel from "./warning_icons_panel";

type RowContentProps = {
  row: Row;
  expandable: boolean;
  expanded: boolean;
  loading: boolean;
  onExpandedToggle: VoidFunction;
  scrollToDate: (date: string) => void;
  childrenCount: number;
};

export const RowContent = ({
  row,
  expandable,
  expanded,
  loading,
  onExpandedToggle,
  scrollToDate,
  childrenCount
}: RowContentProps): JSX.Element => {
  const { shouldDisplayUtilization, utilizationValue } = useUtilization({ row });

  const hoursBooked = useRowHoursBooked({ row });
  const infoText = useInfoText({ row });

  const secondaryText = compact([hoursBooked, infoText]).join(" · ");

  return (
    <div className={css.nameAndButtons}>
      {expandable && (
        <RowExpander
          row={row}
          onClick={onExpandedToggle}
          disabled={expanded && loading}
          expanded={expanded && !!childrenCount}
        />
      )}
      <div
        className={classNames(css.itemContent, {
          [css.noExpandArrow]: !expandable
        })}
      >
        <div className={css.itemContentTop}>
          <div className={css.itemContent}>
            <RowName row={row} />
          </div>
          <div className={css.itemSecondaryContent}>
            <WarningIconsPanel row={row} isRowExpanded={expanded} scrollToDate={scrollToDate} />
            <RowBadge row={row} />
            {shouldDisplayUtilization && <Utilization value={utilizationValue!} />}
            <div className={css.secondaryText}>{secondaryText}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
